<template>
  <div>
    <v-container
      :class="{
        'px-5': $vuetify.breakpoint.lgAndUp,
      }"
    >
      <div class="row pt-3">
        <div class="col s12 m8 l6">
          <v-card elevation="2" style="border-radius: 10px; padding: 16px">
            <manage-open-time-bot v-if="botStatus"></manage-open-time-bot>
          </v-card>
        </div>
      </div>

      <div class="row">
        <div class="col s12 m8 l6">
          <v-card elevation="2" style="border-radius: 10px; padding: 16px">
            <div class="row">
              <div class="col s8">
                <Typography h4 bold :label="$t('Disallowing a bot to reply repeated questions')" />
              </div>
              <div class="col s4 right-align">
                <toggle-button
                  :value="pauseStatus"
                  :sync="true"
                  :color="$vuetify.theme.success"
                  @change="togglePauseStatus()"
                  :labels="{ checked: 'ON', unchecked: 'OFF' }"
                  style="display: inline-block"
                />
              </div>
              <div class="col s12" style="margin-top: 10px">
                <Typography
                  h6
                  color="color-lightMediumGrey"
                  medium
                  :label="
                    $t('*Affect only for Conversation Page (not include Reply to Comment Page)')
                  "
                />
              </div>
            </div>
          </v-card>
        </div>
      </div>

      <div class="row">
        <div class="col s12 m8 l6">
          <v-card elevation="2" style="border-radius: 10px; padding: 16px">
            <div>
              <v-layout wrap>
                <div class="row">
                  <div class="col s8"><Typography h4 bold :label="$t('Typing Time')" /></div>
                  <div class="col s4 right-align">
                    <div v-if="!isEditDelay" @click="isEditDelay = true">
                      <img
                        src="/static/img/TooltipEdit.png"
                        alt
                        class="responsive-img pointer"
                        style="height: 22px"
                      />
                    </div>
                    <div v-if="isEditDelay" @click="onSaveEditDelayMessage">
                      <img
                        src="/static/img/editConfirm.png"
                        alt
                        class="responsive-img pointer"
                        style="height: 22px"
                      />
                    </div>
                  </div>
                  <div class="col s12" style="margin-top: 10px; white-space: break-spaces">
                    <Typography
                      h6
                      color="color-lightMediumGrey"
                      medium
                      :label="
                        $t(
                          'User can set the typing time for Bot to reply, and it will apply to all conversation.'
                        )
                      "
                    />
                    <v-flex xs12 sm6 lg6 class="text-xs-center">
                      <div class="form-setting">
                        <v-layout class="setting-box active pa-2 color-darkBlue" v-if="isEditDelay">
                          <v-flex xs9 sm9 lg9 class="left-align">
                            <div style="display: flex; flex-direction: row; gap: 5px">
                              <img
                                src="/static/img/time.png"
                                alt
                                class="responsive-img"
                                style="height: 24px; width: 24px"
                              />
                              <input
                                type="text"
                                autofocus
                                :placeholder="$t('name')"
                                v-model.lazy="delayMessageTime"
                                maxlength="255"
                                class="form-setting"
                              />
                            </div>
                          </v-flex>
                          <v-flex xs3 sm3 lg3 class="right-align">
                            <Typography h5 medium label="วินาที" />
                          </v-flex>
                        </v-layout>
                        <v-layout class="setting-box pa-2 color-darkBlue" v-else>
                          <v-flex xs9 sm9 lg9 class="left-align">
                            <div style="display: flex; flex-direction: row; gap: 5px">
                              <img
                                src="/static/img/time.png"
                                alt
                                class="responsive-img"
                                style="height: 24px; width: 24px"
                              />
                              <Typography h5 medium :label="`${delayMessageTime}`" />
                            </div>
                          </v-flex>
                          <v-flex xs3 sm3 lg3 class="right-align">
                            <Typography h5 medium label="วินาที" />
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-flex>
                  </div>
                </div>
              </v-layout>
            </div>
          </v-card>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import ManageOpenTimeBot from './ManageOpenTimeBot'
import { ToggleButton } from 'vue-js-toggle-button'
import Typography from '@/components/elements/Typography.vue'

export default {
  data: function () {
    return {
      expriedDate: null,
      expriedTime: null,
      botStatus: false,
      pauseStatus: false,
      delayMessageTime: 0,
      isEditDelay: false,
    }
  },
  watch: {
    selectedBotStatus() {
      let vm = this
      vm.botStatus = vm.selectedBot.status
    },
  },
  mounted: async function () {
    var vm = this
    vm.botStatus = vm.selectedBot.status
    await vm.getPauseStatus()
    await vm.getDelayMessage()
    vm.cached_delay_message_time = vm.delayMessageTime
  },
  components: {
    ManageOpenTimeBot,
    ToggleButton,
    Typography,
  },
  methods: {
    getDelayMessage: function () {
      var vm = this
      return new Promise((resolve, reject) => {
        api.getReplyDelay({ pageid: vm.selectedBot.pageid }, function (error, response) {
          if (error) {
            reject(error)
          }
          vm.delayMessageTime = response.data.replydelay / 1000
          resolve()
        })
      })
    },
    onCancelEditDelayMessage: function () {
      var vm = this
      vm.delayMessageTime = vm.cached_delay_message_time
      vm.isEditDelay = false
    },
    onSaveEditDelayMessage: function () {
      var vm = this
      vm.$store.dispatch('loading')
      return new Promise((resolve, reject) => {
        api.editReplyDelay(
          { pageid: vm.selectedBot.pageid, replydelay: vm.delayMessageTime * 1000 },
          function (error, response) {
            if (error) {
              reject(error)
              vm.$store.dispatch('loading')
            }
            vm.cached_delay_message_time = vm.delayMessageTime
            vm.isEditDelay = false
            vm.$store.dispatch('loading')
            resolve()
          }
        )
      })
    },
    decrementDelayMessage() {
      this.delayMessageTime -= 0.5
    },
    incrementDelayMessage() {
      this.delayMessageTime += 0.5
    },
    onChangeDelayMessage: function () {},
    getPauseStatus: function () {
      var vm = this
      return new Promise((resolve, reject) => {
        api.getPauseStatus({ pageid: vm.selectedBot.pageid }, function (error, response) {
          if (error) {
            reject(error)
          }
          vm.pauseStatus = response.data.notreplyduplicateintent === true
          resolve()
        })
      })
    },
    toggleBotStatus: function () {
      let vm = this
      let bot = Object.assign({}, vm.selectedBot)
      bot.status = !bot.status
      let data = {
        theme: bot.theme,
        page_access_token: bot.page_access_token,
        pageid: bot.pageid,
        status: bot.status,
      }
      vm.$store.dispatch('loading')
      api.toggleBotStatus(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
          return
        }

        let newbotlist = vm.botlist
        $.each(newbotlist, function (index, oldbot) {
          if (bot.pageid === oldbot.pageid) {
            newbotlist[index].status = bot.status
            return false
          }
        })
        vm.botStatus = bot.status
        vm.$store.dispatch('selectBot', bot)
        vm.$store.dispatch('updateBotlist', newbotlist)
        vm.$store.dispatch('loading')
      })
    },
    togglePauseStatus: function () {
      let vm = this
      vm.pauseStatus = !vm.pauseStatus
      var data = {
        pageid: vm.selectedBot.pageid,
        notreplyduplicateintent: vm.pauseStatus,
      }

      vm.$store.dispatch('loading')
      api.togglePauseStatus(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
          return
        }
        vm.selectedBot.notreplyduplicateintent = vm.pauseStatus
        vm.$store.dispatch('loading')
      })
    },
  },
}
</script>

<style>
.rounded-card {
  border-radius: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/view/billing/GeneralSetting.vue